import { StatisticDtoScore } from "components/StatisticsDataTable/Dto/DataTableStatisticDto";

export const SCORE_COL_INDEX = 8;
export const DEFAULT_SCORE: StatisticDtoScore = { scoredPoints: 0, maxPoints: 0 };

export const getScoreFromRowData = (rowData: unknown[]): StatisticDtoScore => {
    const raw = rowData?.[SCORE_COL_INDEX] as unknown;
    return isScore(raw) ? raw : DEFAULT_SCORE;
};

export const isScore = (v: unknown): v is StatisticDtoScore =>
    typeof v === 'object' &&  v !== null &&  'scoredPoints' in v &&  'maxPoints' in v;

export const getScoreFromRow = (row: unknown): StatisticDtoScore => {
    const candidate = (row as { data?: unknown })?.data ?? row;
    return isScore(candidate) ? candidate : DEFAULT_SCORE;
};

export type ScoreFilterLabels = {
  noPoints: string;
  below50: string;
  above50: string;
  max: string;
};

export const makeScoreFilterLogic = (
  labels: ScoreFilterLabels,
  getScore: (rowData: unknown[]) => StatisticDtoScore
) => {
  return (_value: unknown, filtersSelected: string[], rowData: unknown[]) => {
    if (!filtersSelected?.length) {
      return false;
    }

    const s = getScore(rowData);
    const pct = s.maxPoints > 0 ? s.scoredPoints / s.maxPoints : 0;

    const buckets: string[] = [];
    if (s.scoredPoints === 0) buckets.push(labels.noPoints);
    if (s.maxPoints > 0 && s.scoredPoints === s.maxPoints) buckets.push(labels.max);
    if (s.maxPoints > 0 && s.scoredPoints > 0 && pct < 0.5) buckets.push(labels.below50);
    if (s.maxPoints > 0 && pct >= 0.5 && s.scoredPoints < s.maxPoints) buckets.push(labels.above50);

    const matches = filtersSelected.some(f => buckets.includes(f));
    return !matches;
  };
};

export const getScoreFromCompareArg = (arg: unknown): StatisticDtoScore => {
  const candidate = (arg as any)?.data ?? arg;
  return isScore(candidate) ? candidate : DEFAULT_SCORE;
};

export const makeSortScore =
  (getScore: (arg: unknown) => StatisticDtoScore) =>
  (order: 'asc' | 'desc') =>
  (a: unknown, b: unknown): number => {
    const sa = getScore(a);
    const sb = getScore(b);

    const ap = sa.maxPoints > 0 ? sa.scoredPoints / sa.maxPoints : -1;
    const bp = sb.maxPoints > 0 ? sb.scoredPoints / sb.maxPoints : -1;

    const diff = ap - bp;
    return order === 'desc' ? -diff : diff;
  };